function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "none",
  stroke: "#194C73",
  strokeWidth: 3.456,
  d: "M25.516,25.781h48.671v48.436H25.516V25.781z"
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 48.717,
  cy: 12.891,
  rx: 4.318,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 17.856,
  cy: 8.594,
  rx: 4.317,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 95.098,
  cy: 32.422,
  rx: 4.317,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 86.166,
  cy: 47.226,
  rx: 4.318,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 94.802,
  cy: 69.922,
  rx: 4.317,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 46.421,
  cy: 88.477,
  rx: 4.318,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 69.87,
  cy: 95.702,
  rx: 4.317,
  ry: 4.298
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 69.87,
  cy: 4.298,
  rx: 4.317,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 4.902,
  cy: 31.936,
  rx: 4.318,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 13.538,
  cy: 54.297,
  rx: 4.318,
  ry: 4.297
}), React.createElement("ellipse", {
  fill: "#009AD7",
  cx: 13.538,
  cy: 84.179,
  rx: 4.318,
  ry: 4.298
}));

var SvgTracking = function SvgTracking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "tracking",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTracking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tracking.2a61092c.svg";
export { ForwardRef as ReactComponent };